import { readProfileLinks } from "./links";

/**
 * «پروفایلت را کامل کن» — the steps that make an account whole, each read from the profile itself (`/auth/profile`),
 * so a step ticks the moment the save that does it lands, and the whole card goes once every step is done.
 *
 *  avatar  — a portrait (`profile.cover`)
 *  banner  — a banner (`profile.banner`)
 *  bio     — a few words about you (`profile.bio`)
 *  email   — an email (`email`)
 *  mobile  — a mobile number (`mobile_number`)
 *  links   — at least one link: website, Telegram, Instagram or Discord (`profile.links`)
 */
export type StepKey = "avatar" | "banner" | "bio" | "email" | "mobile" | "links";
export const STEP_KEYS: StepKey[] = ["avatar", "banner", "bio", "email", "mobile", "links"];

type ProfileLike = {
  email?: string | null;
  mobile_number?: string | null;
  profile?: { cover?: string | null; banner?: string | null; bio?: string | null; links?: unknown } | null;
} | null | undefined;

const filled = (v: unknown) => typeof v === "string" && v.trim().length > 0;

export function profileSteps(user: ProfileLike): { key: StepKey; done: boolean }[] {
  const p = user?.profile ?? {};
  const links = readProfileLinks(p.links);
  const done: Record<StepKey, boolean> = {
    avatar: filled(p.cover),
    banner: filled(p.banner),
    bio: filled(p.bio),
    email: filled(user?.email),
    mobile: filled(user?.mobile_number),
    links: ["website", "telegram", "instagram", "discord"].some((k) => filled(links[k])),
  };
  return STEP_KEYS.map((key) => ({ key, done: done[key] }));
}
